import React, { useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import classNames from 'classnames'
import { NavLink } from 'react-router-dom'
import { CContainer, CHeader, CHeaderNav, CHeaderToggler, CSidebarBrand } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilMenu } from '@coreui/icons'
import { AppHeaderDropdown } from './header/index'
import logoIcon from 'src/assets/brand/logo_icon.png'
import logoText from 'src/assets/brand/logo_text.png'

const AppHeader = () => {
  const headerRef = useRef()

  const dispatch = useDispatch()
  const sidebarShow = useSelector((state) => state.sidebarShow)

  useEffect(() => {
    document.addEventListener('scroll', () => {
      headerRef.current &&
        headerRef.current.classList.toggle('shadow-sm', document.documentElement.scrollTop > 0)
    })
  }, [])

  return (
    <CHeader position="sticky" className="mb-4" ref={headerRef}>
      <CContainer className="px-4" fluid>
        <CHeaderToggler
          className={classNames('d-lg-none', {
            'prevent-hide': !sidebarShow,
          })}
          onClick={() => dispatch({ type: 'set', sidebarShow: !sidebarShow })}
          style={{ marginInlineStart: '-14px' }}
        >
          <CIcon icon={cilMenu} size="lg" />
        </CHeaderToggler>

        <CSidebarBrand as={NavLink} to="/">
          <div className="d-flex gap-2">
            <div className="logoIcon">
              <img src={logoIcon} alt="Logo" height={40} />
            </div>
            <div className="logoText">
              <img src={logoText} alt="Logo" height={40} />
            </div>
          </div>
        </CSidebarBrand>

        <CHeaderNav className="ms-auto ms-md-0">
          <AppHeaderDropdown />
        </CHeaderNav>
      </CContainer>
    </CHeader>
  )
}

export default AppHeader
